import { FiArrowRight } from "react-icons/fi";
import { ceo } from "../assets";
import styles from "../style";
import { Reveal } from "./reveal";


const Mission = () => (  
  <div className={`${styles.flexCenter} flex-col gap-10 mt-10`}>
    <div className={`w-full justify-center items-start flex flex-col md:flex-row py-20 px-10 md:gap-20 gap-10`}>  
      <Reveal className="flex flex-col gap-4 items-start md:items-end py-40 pb-16">
        <h2 className="text-sm font-semibold">
          About Us
        </h2>
        <h2 className="py-4 xs:text-md text-md font-semibold max-w-[300px]">
          Mission
        </h2>
      </Reveal>
      
      <div className="flex flex-col gap-4 items-start">
        <Reveal>
          <div className={`pb-14 flex flex-col items-start`}>
            <p className={`font-medium xs:text-mm text-mm text-start my-2 max-w-[800px]`}>
              Our work is grounded in the belief that safeguarding is not only a policy requirement. It is a daily practice shaped by culture, leadership, professional judgement and clear systems.
            </p>

            <p className={`text-secondary xs:text-mm text-sm text-start my-6 max-w-[800px]`}>
              We help schools move from written expectations to lived practice by combining consultation, observation, tailored training and implementation support.
            </p>

            <Reveal>
              <div className="flex flex-row items-center justify-center gap-2">
                <div className="w-[30px] h-[30px] bg-second items-center justify-center flex  mr-2">
                  <FiArrowRight size={20} className="text-fourth" />
                </div>
                <h2 className="text-sm font-semibold">
                  Meet Our Team
                </h2>
              </div>
            </Reveal>

            <span className="my-6 border-b border-0.5 border-second w-full"></span> 

            <div className="flex md:flex-row flex-col items-start justify-center gap-2 mt-6 w-full justify-between">
              <div className="flex flex-col gap-2">
                <Reveal>
                  <div className={`pb-14 flex flex-col gap-4 items-start`}>
                    <p className={`font-medium text-sm text-start my-2 max-w-[400px]`}>
                      Aegis Education Group was founded by Emilianne Gathitu, a school leader, educator and safeguarding practitioner with international school experience across teaching, leadership, safeguarding, staff development and systems improvement.
                    </p>

                    <p className={`text-secondary text-sm text-start my-6 max-w-[400px]`}>
                    Emilianne’s work is practical and school facing. She supports leaders and staff to make safeguarding clearer, more consistent and more embedded in everyday school life.
                    </p>

                    <span className="my-6 border-b border-0.5 border-second w-full"></span>        
                  </div>        
                </Reveal>
              </div>
              <div className="w-[300px] h-[340px] overflow-hidden">
                <img src={ceo} alt="" className="w-full h-full object-cover" />
              </div>
            </div>         
          </div>        
        </Reveal>
        
      </div>     
    </div>
  </div>
);

export default Mission;
